/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:31 2019-07-06
 */
import Keep from "../layout/keep";
import Layout from '../layout/layout';

let AlarmManage = [
    {
        path: '/:type/alarmManage',
        name: 'alarmManage',
        component: Layout,
        children: [
            {
                path: 'alarmSearch',
                name: 'alarmSearch',
                meta: { title: '报警查询' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'alarm-manage-alarm-search',
                        meta: { title: '报警查询' },
                        component: () => import('src/pages/alarmManage/alarmSearch/alarmSearch'),
                    },
                ],
            },
            {
                path: 'alarmStatistics',
                name: 'alarmStatistics',
                meta: { title: '报警统计' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'alarm-manage-alarm-statistics',
                        meta: { title: '报警统计' },
                        component: () => import('src/pages/alarmManage/alarmStatistics/alarmStatistics'),
                    },
                ],
            },
        ],
    },
]

export default AlarmManage
